import {Injectable, signal} from '@angular/core';
import {fileKeyState, filePath, fileTypeState, modalPath} from "../configs/turnkey-cost-modal-config";
import {EntityFileType} from "../../../../../../../core/types/file.types";

@Injectable({
  providedIn: 'root'
})
export class TpTurnkeyCostPathStateService {
  private _pathState = signal<string>('');
  private _pathFileState = signal<string>('');
  private _fileTypeState = signal<EntityFileType>('TURNKEY_COST_TO_WAREHOUSE');
  private _fileKeyState = signal<string>('');
  public pathState = this._pathState.asReadonly();
  public pathFileState = this._pathFileState.asReadonly();
  public fileTypeState = this._fileTypeState.asReadonly();
  public fileKeyState = this._fileKeyState.asReadonly();

  public setPathState(modalKey: string): void {
    this._pathState.set(modalPath[modalKey]);
    this._pathFileState.set(filePath[modalKey]);
    this._fileTypeState.set(fileTypeState[modalKey]);
    this._fileKeyState.set(fileKeyState[modalKey]);
  }

  public resetPathState(): void {
    this._pathState.set('');
    this._pathFileState.set('');
    this._fileTypeState.set('TURNKEY_COST_TO_WAREHOUSE');
    this._fileKeyState.set('');
  }
}
